module.exports = __webpack_public_path__ + "img/auth9.0daab726.png";